export const bytesToGigabytes = (bytes) => bytes / (1024 * 1024 * 1024);
